import { Button, Text } from "@mantine/core";
import { useContext, useEffect, useState } from "react";
import { WebPhoneContext } from "../functions/WebPhoneContext";
import { Phone } from "tabler-icons-react";
import { FormattedMessage, useIntl } from "react-intl";
import { toTeltelDialNumber } from "../functions/phone";

const buttonStyle = {
  flex: 1,
  minWidth: 250,
  maxWidth: 350,
  margin: "5px 10px",
};

function canDial(phone) {
  return (
    phone &&
    typeof phone === "object" &&
    typeof phone.call === "function" &&
    phone.call !== Function.prototype.call
  );
}

export const CallButton = ({ client }) => {
  const { phone } = useContext(WebPhoneContext);
  const intl = useIntl();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!canDial(phone) || typeof phone.event !== "function") {
      return;
    }
    const handler = function (data) {
      if (data.event == "RING" && typeof phone.info === "function") {
        const fromLabel = intl.formatMessage({ id: "call_from" }) + data.caller;
        const toLabel = intl.formatMessage({ id: "call_to" }) + data.callee;
        let line2;
        if (data.direction == "inbound") {
          line2 = {
            type: "link",
            target: "_blank",
            url: "https://www.google.com/search?q=" + data.caller,
            text: fromLabel,
          };
        } else {
          line2 = fromLabel;
        }

        phone.info({
          line1: data.event,
          line2: line2,
          line3: toLabel,
        });
      }
    };
    phone.event("all", handler);
  }, [phone, intl]);

  const engageCall = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setError(null);

    const instance = canDial(phone)
      ? phone
      : canDial(window.__teltelPhone)
        ? window.__teltelPhone
        : null;

    if (!instance) {
      setError(intl.formatMessage({ id: "call_phone_unavailable" }));
      return;
    }

    const number = toTeltelDialNumber(client && client.c_phone);
    if (!number) {
      setError(intl.formatMessage({ id: "call_no_number" }));
      return;
    }

    instance.call(number);
    if (typeof instance.info === "function") {
      instance.info({
        line1: "calling to",
        line2: number,
        line3: {
          type: "link",
          target: "callback",
          text: ((client && client.c_name) || "") + " " + ((client && client.c_surname) || ""),
        },
      });
    }
  };

  return (
    <div>
      <Button
        type="button"
        variant="outline"
        color="purple"
        radius={0}
        onClick={engageCall}
        style={{ ...buttonStyle, backgroundColor: "dodgerblue", color: "white" }}
      >
        <Phone
          size={18}
          strokeWidth={2}
          color={"white"}
          style={{ marginRight: 5 }}
        />
        <FormattedMessage id="call_client" />
      </Button>
      {error && (
        <Text color="red" size="sm" mt={4}>
          {error}
        </Text>
      )}
    </div>
  );
};
